const socket = window.io.connect('http://192.168.1.128:3000');

export const getSocket = () => socket;

export const emit = (type, message) => socket.emit(type, message);
